module.exports = __webpack_public_path__ + "img/lair-blueprint.c0a090af.png";